import React from 'react';
import axios from 'axios';
import { withRouter } from 'react-router-dom';
import './../../../pages/Representante_Instituição/Tela_RI_Cadastro/styles.css';

class Cadastro_ME extends React.Component {
    constructor() {
        super();
        this.state = {
            authenticated: false,
            name: "",
            crm: "",
            regional_council_state: "",
            phone: "",
            cpf: "",
            rg:"",
            federative_unit:"",
            address:"",
            cep:"",
            email: "",
            gender: "",
            birth: "",
            password: "",
            occupation_area:"",
            medical_specialty: "",
            health_specialty: "",
            voluntary: "Profissional de saude",
            voluntary_type: "",
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleSelect_vt = this.handleSelect_vt.bind(this);
        this.handleSelect_ms = this.handleSelect_ms.bind(this);
        this.handleSelect_g = this.handleSelect_g.bind(this);
        this.handleSelect_uf1 = this.handleSelect_uf1.bind(this);
        this.handleSelect_uf2 = this.handleSelect_uf2.bind(this);
    }
    handleChange(evt) {
        this.setState({ [evt.target.name]: evt.target.value });
    }

    handleSelect(event) {
        this.setState({ occupation_area: event.target.value });
    }

    handleSelect_ms(event) {
        this.setState({ medical_specialty: event.target.value });
    }

    handleSelect_vt(event) {
        this.setState({ voluntary_type: event.target.value });
    }

    handleSelect_g(event){
        this.setState({ gender: event.target.value});
    }

    handleSelect_uf1(event){
        this.setState({federative_unit: event.target.value});
    }

    handleSelect_uf2(event){
        this.setState({regional_council_state: event.target.value})
    }

    handleSubmit = evt => {
        evt.preventDefault();

        const professional = {
            authenticated: this.state.authenticated,
            name: this.state.name,
            crm: this.state.crm,
            regional_council_state: this.state.regional_council_state,
            phone: this.state.phone,
            cpf: this.state.cpf,
            rg: this.state.rg,
            federative_unit: this.state.federative_unit,
            address: this.state.address,
            cep: this.state.cep,
            email: this.state.email,
            gender: this.state.gender,
            birth: this.state.birth,
            password: this.state.password,
            occupation_area: this.state.occupation_area,
            medical_specialty: this.state.medical_specialty,
            health_specialty: this.state.health_specialty,
            voluntary: this.state.voluntary,
            voluntary_type: this.state.voluntary_type,

        };

        console.log(professional);

        axios.post(`https://convida-api-official.herokuapp.com/professional`, professional)
            .then(res => {
                console.log(res);
                console.log(res.data);
                alert("Usuário cadastrado com sucesso! Obrigado por utilizar a Plataforma Convida!");
                this.props.history.push("/login_m");
            })

            .catch(error => {
                console.log(error);
                console.log(error.data);
            });

    }

    render() {
        return (
            <form onSubmit={this.handleSubmit} id="forms-RI-Cadastro">
                <h1 id="tittle-forms-cme">Formulário de Cadastro</h1>
                <br></br>

                <p id="RI-Title-Cadastro-Paciente" >E-mail</p>
                <input onChange={this.handleChange} name="email" placeholder="Insira seu e-mail: " id="RI-Cadastro" required/>

                <p id="RI-Title-Cadastro-Paciente" >Nome completo</p>
                <input onChange={this.handleChange} name="name" placeholder="Insira seu nome completo: " id="RI-Cadastro" required/>

                <p id="RI-Title-Cadastro-Paciente" >Genêro</p>
                <select value={this.state.gender} onChange={this.handleSelect_g} id="RI-Solicitar-Forms" required>
                    <option>Selecionar</option>
                    <option value='Masculino'>Masculino</option>
                    <option value='Feminino'>Feminino</option>
                    <option value='Outro'>Outro</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Data de Nascimento</p>
                <input onChange={this.handleChange} type="date" name="birth" placeholder="Insira sua data de nascimento: " id="RI-Cadastro" required/>

                <p id="RI-Title-Cadastro-Paciente" >RG</p>
                <input onChange={this.handleChange} name="rg" placeholder="Insira seu RG: " id="RI-Cadastro" required/>

                <p id="RI-Title-Cadastro-Paciente" >Unidade Federativa</p>
                <select value={this.state.federative_unit} onChange={this.handleSelect_uf1} id="RI-Solicitar-Forms" required>
                    <option>Selecionar</option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >CPF</p>
                <input onChange={this.handleChange} name="cpf" placeholder="Insira seu CPF: " id="RI-Cadastro" required/>

                <p id="RI-Title-Cadastro-Paciente" >Endereço</p>
                <input onChange={this.handleChange} name="address" placeholder="Insira seu endereço: " id="RI-Cadastro" />

                <p id="RI-Title-Cadastro-Paciente" >CEP</p>
                <input onChange={this.handleChange} name="cep" placeholder="Insira seu CEP: " id="RI-Cadastro" />

                <p id="RI-Title-Cadastro-Paciente" >Telefone</p>
                <input onChange={this.handleChange} name="phone" placeholder="Insira seu (DDD) e Telefone: " id="RI-Cadastro" />

                <p id="RI-Title-Cadastro-Paciente" >Número do Conselho Profissional</p>
                <input onChange={this.handleChange} name="crm" placeholder="Insira seu Número do Conselho Profissional: " id="RI-Cadastro" required/>

                <p id="RI-Title-Cadastro-Paciente" >UF do seu Número do Conselho Profissional</p>
                <select value={this.state.regional_council_state} onChange={this.handleSelect_uf2} id="RI-Solicitar-Forms" required>
                    <option>Selecionar</option>
                    <option value="AC">Acre</option>
                    <option value="AL">Alagoas</option>
                    <option value="AP">Amapá</option>
                    <option value="AM">Amazonas</option>
                    <option value="BA">Bahia</option>
                    <option value="CE">Ceará</option>
                    <option value="DF">Distrito Federal</option>
                    <option value="ES">Espírito Santo</option>
                    <option value="GO">Goiás</option>
                    <option value="MA">Maranhão</option>
                    <option value="MT">Mato Grosso</option>
                    <option value="MS">Mato Grosso do Sul</option>
                    <option value="MG">Minas Gerais</option>
                    <option value="PA">Pará</option>
                    <option value="PB">Paraíba</option>
                    <option value="PR">Paraná</option>
                    <option value="PE">Pernambuco</option>
                    <option value="PI">Piauí</option>
                    <option value="RJ">Rio de Janeiro</option>
                    <option value="RN">Rio Grande do Norte</option>
                    <option value="RS">Rio Grande do Sul</option>
                    <option value="RO">Rondônia</option>
                    <option value="RR">Roraima</option>
                    <option value="SC">Santa Catarina</option>
                    <option value="SP">São Paulo</option>
                    <option value="SE">Sergipe</option>
                    <option value="TO">Tocantins</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Qual sua área de atuação?</p>
                <select value={this.state.occupation_area} onChange={this.handleSelect} id="RI-Solicitar-Forms" required>
                    <option>Selecionar</option>
                    <option value='Medicina'>Medicina</option>
                    <option value='Psicologia'>Psicologia</option>
                    <option value='Fisioterapia'>Fisioterapia</option>
                    <option value='Odontologia'>Odontologia</option>
                    <option value='Enfermagem'>Enfermagem</option>
                    <option value='Nutrição'>Nutrição</option>
                    <option value='Outros'>Outros</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Especialidade Médica</p>
                <select value={this.state.medical_specialty} onChange={this.handleSelect_ms} id="RI-Solicitar-Forms">
                    <option>Selecionar</option>
                    <option value='Acupuntura'>Acupuntura</option>
                    <option value='Alergia e imunologia'>Alergia e imunologia</option>
                    <option value='Anestesiologia'>Anestesiologia</option>
                    <option value='Angiologia'>Angiologia</option>
                    <option value='Cardiologia'>Cardiologia</option>
                    <option value='Cirurgia cardiovascular'>Cirurgia cardiovascular</option>
                    <option value='Cirurgia da mão'>Cirurgia da mão</option>
                    <option value='Cirurgia de cabeça e pescoço'>Cirurgia de cabeça e pescoço</option>
                    <option value='Cirurgia do aparelho digestivo'>Cirurgia do aparelho digestivo</option>
                    <option value='Cirurgia geral'>Cirurgia geral</option>
                    <option value='Cirurgia oncológica'>Cirurgia oncológica</option>                   
                    <option value='Cirurgia pediátrica'>Cirurgia pediátrica</option>
                    <option value='Cirurgia plástica'>Cirurgia plástica</option>
                    <option value='Cirurgia torácica'>Cirurgia torácica</option>                    
                    <option value='Cirurgia vascular'>Cirurgia vascular</option>
                    <option value='Clínica médica'>Clínica médica</option>
                    <option value='Coloproctologia'>Coloproctologia</option>                   
                    <option value='Dermatologia'>Dermatologia</option>
                    <option value='Endocrinologia e metabologia'>Endocrinologia e metabologia</option>
                    <option value='Endoscopia'>Endoscopia</option>                    
                    <option value='Gastroenterologia'>Gastroenterologia</option>
                    <option value='Genética médica'>Genética médica</option>
                    <option value='Geriatria'>Geriatria</option>                    
                    <option value='Ginecologia e obstetrícia'>Ginecologia e obstetrícia</option>
                    <option value='Hematologia e hemoterapia'>Hematologia e hemoterapia</option>
                    <option value='Homeopatia'>Homeopatia</option>
                    <option value='Infectologia'>Infectologia</option>
                    <option value='Mastologia'>Mastologia</option>
                    <option value='Medicina de emergência'>Medicina de emergência</option>                    
                    <option value='Medicina de família e comunidade'>Medicina de família e comunidade</option>
                    <option value='Medicina do trabalho'>Medicina do trabalho</option>
                    <option value='Medicina de tráfego'>Medicina de tráfego</option>
                    <option value='Medicina esportiva'>Medicina esportiva</option>
                    <option value='Medicina física e reabilitação'>Medicina física e reabilitação</option>
                    <option value='Medicina intensiva'>Medicina intensiva</option>                    
                    <option value='Medicina legal e perícia médica'>Medicina legal e perícia médica</option>
                    <option value='Medicina nuclear'>Medicina nuclear</option>
                    <option value='Medicina preventiva e social'>Medicina preventiva e social</option>
                    <option value='Nefrologia'>Nefrologia</option>
                    <option value='Neurocirurgia'>Neurocirurgia</option>
                    <option value='Neurologia'>Neurologia</option>                    
                    <option value='Nutrologia'>Nutrologia</option>
                    <option value='Oftalmologia'>Oftalmologia</option>
                    <option value='Oncologia clínica'>Oncologia clínica</option>
                    <option value='Ortopedia e traumatologia'>Ortopedia e traumatologia</option>
                    <option value='Otorrinolaringologia'>Otorrinolaringologia</option>
                    <option value='Patologia'>Patologia</option>                    
                    <option value='Patologia clínica/medicina laboratorial'>Patologia clínica/medicina laboratorial</option>
                    <option value='Pediatria'>Pediatria</option>
                    <option value='Pneumologia'>Pneumologia</option>
                    <option value='Psiquiatria'>Psiquiatria</option>
                    <option value='Radiologia e diagnóstico por imagem'>Radiologia e diagnóstico por imagem</option>
                    <option value='Radioterapia'>Radioterapia</option>
                    <option value='Reumatologia'>Reumatologia</option>
                    <option value='Urologia'>Urologia</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Especialidade na área da Saúde</p>
                <input onChange={this.handleChange} name="health_specialty" placeholder="Caso atuante em outras áreas da saúde, qual a especialidade? " id="RI-Cadastro" />

                <p id="RI-Title-Cadastro-Paciente" >Tipo de voluntário</p>
                <select value={this.state.voluntary_type} onChange={this.handleSelect_vt}  id="RI-Solicitar-Forms" required>
                    <option>Selecionar</option>
                    <option value='Atendimento in loco nas instituições (Presencial)'>Atendimento in loco nas instituições (Presencial)</option>
                    <option value='Atendimento via telessaúde (Online)'>Atendimento via telessaúde (Online)</option>
                    <option value='Ambos (Online e Presencial)'>Ambos (Online e Presencial)</option>
                </select>

                <p id="RI-Title-Cadastro-Paciente" >Senha</p>
                <input onChange={this.handleChange} name="password" placeholder="Insira uma senha: " id="RI-Cadastro" required/>
                
                <button onClick={() => this.handleSubmit} id="RI-Cadastro">Enviar</button>
            </form>
        );
    }
}

Cadastro_ME = withRouter(Cadastro_ME);
export default Cadastro_ME;

